import React, { FC } from 'react'
import { PolaroidList } from 'components/SA/Polaroid'
import ListConnector, { ConnectorProps as ListProps } from '../../connectors/List'
import styles from './FeaturePolaroidList.module.scss'

type FeaturePolaroidListProps = ListProps & {
  isAlgoliaLoading?: boolean
  searchQuery: string | null
  title: string
}

const FeaturePolaroidList: FC<FeaturePolaroidListProps> = ({
  algoliaIndice,
  algoliaUserToken,
  artworks,
  isScreenReady,
  userID,
  title,
  searchQuery,
  isAlgoliaLoading,
}) => {

  const dataLayerListName = searchQuery ? `Results for "${searchQuery}"` : title

  const handleCheckIsPrintForDataLayerEvent = ({ hasOpenEditions }) => hasOpenEditions

  return (
    <PolaroidList
      algoliaIndice={algoliaIndice}
      algoliaUserToken={algoliaUserToken}
      dataApi='algolia'
      dataList='feature-results'
      dataListId='feature-results'
      dataListName={dataLayerListName}
      artworks={artworks}
      isLoading={!isScreenReady || isAlgoliaLoading}
      userID={userID}
      isPrintsFromVisible={false}
      onCheckIsPrintForDataLayerEvent={handleCheckIsPrintForDataLayerEvent}
      skeletonQuantity={100}
      customStyle={styles.customPolaroidListContainer}
    />
  )
}

export default ListConnector(FeaturePolaroidList)
